import type { ListTableProps } from '../ListTable'
import { useMemo, useContext } from 'react'
import { observer } from 'mobx-react'
import { Checkbox, Pagination } from 'antd'
import { PictureThumb, ListTableContext } from 'src/components'
import { get } from 'lodash'

type Props = {
  onSelect?: (record: any, selected: boolean) => void
} & Pick<ListTableProps, 'checkboxEnable' | 'singlePageTable'>

const ListTableCard = (props: Props) => {
  const state = useContext(ListTableContext)

  const dataSource = useMemo(() => {
    const data = state.tableData.dataSource ?? []
    const fakeCount = Math.ceil(data.length / 4) * 4 - data.length
    return data.concat(new Array(fakeCount).fill(false))
  }, [state.tableData.dataSource])

  return (
    <div className='full-parent text-right'>
      <div className='list-table__card'>
        {
          dataSource.map((item: any, index: number) => {
            if (!item) return <div key={`fake_${index}`} className='list-table__card-item fake' />

            const thumbCode = get(item, state.tableConfig.PageTable.PIC_CODE_FIELD)
            return (
              <div key={item.ID} className='list-table__card-item'>
                {
                  props.checkboxEnable
                    ? (
                      <Checkbox
                        checked={state.selectedKeys.indexOf(item.ID) !== -1}
                        onChange={evt => props.onSelect?.(item, evt.target.checked)}
                        className='list-table__card-checkbox'
                      />
                    )
                    : null
                }
                {
                  state.tableData.columns.map((col: any, index: number) => {
                    return (
                      <div key={col.key} className='list-table__card-column' style={index === 0 ? { padding: 0 } : {}}>
                        <span className={index === 0 ? 'fz-16' : 'fz-14'}>{col.title}：{col.render(item[col.dataIndex], item)}</span>
                        {index === 0 ? <div className='list-table__card-divider' /> : null}
                      </div>
                    )
                  })
                }
                {
                  thumbCode
                    ? (
                      <PictureThumb
                        picFilter={state.tableConfig.Nav_PicFilter}
                        targetData={item}
                        className='list-table__card-pic'
                      />
                    )
                    : null
                }
              </div>
            )
          })
        }
      </div>
      {
        !props.singlePageTable
          ? (
            <Pagination
              size='small'
              {...state.paginationOption}
              onChange={(page, pageSize) => state.setPagination({ current: page, pageSize })}
              className='mg-t2'
            />
          )
          : null
      }
    </div>
  )
}

export default observer(ListTableCard)